import React, { useState } from "react";
import CALENDAR_ICON from "../../../assets/Calendar.png";
import CALENDAR_BLANK_ICON from "../../../assets/CalendarBlank.png";
import CLOCK_ICON from "../../../assets/Clock.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ITEM_COURSE } from "../../../constants/text_constants";
import handleBuy from "../../Buy/handleBuy";

const DescriptionTop = ({
  course_banner,
  starts_on,
  ends_on,
  validity,
  duration,
  offer_discount,
  offer_price,
  price,
  id,
  name,
  principal_amount,
  course_icon,
  is_purchased,
  payment_plans = [],
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPlanPopup, setShowPlanPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const plans = Array.isArray(payment_plans)
    ? payment_plans.filter(Boolean)
    : [];

  const openBuyPopup = () => {
    // No payment plans -> existing direct buy flow
    if (plans.length === 0) {
      handleBuy(
        dispatch,
        navigate,
        id,
        ITEM_COURSE,
        name,
        offer_price,
        offer_discount,
        price,
        principal_amount,
        course_banner,
        course_icon
      );

      return;
    }

    // Payment plans available -> show popup
    setSelectedPlan(null);
    setShowPlanPopup(true);
  };

  const continueToPayment = () => {
    if (!selectedPlan) return;

    const finalPrice =
      Number(selectedPlan?.offer_discount || 0) > 0
        ? selectedPlan?.offer_price
        : selectedPlan?.price;

    handleBuy(
      dispatch,
      navigate,
      id,
      ITEM_COURSE,
      name,
      finalPrice,
      selectedPlan?.offer_discount,
      selectedPlan?.price,
      principal_amount,
      course_banner,
      course_icon,
      selectedPlan?.id
    );

    setShowPlanPopup(false);
  };

  return (
    <>
      <div>
        {/* Banner Image */}
        <img
          src={course_banner}
          alt="course"
          className="w-full rounded-2xl"
        />

        {/* KPI Cards */}
        <div className="my-5 flex justify-center">
          <div className="grid grid-cols-2 gap-x-[2rem] gap-y-[0.7rem]">
            {/* start date */}
            <div className="flex items-start gap-2 rounded-2xl border border-[#5A277C] px-2 py-1">
              <div>
                <img
                  src={CALENDAR_BLANK_ICON}
                  alt={starts_on}
                  className="mt-1"
                  loading="lazy"
                />
              </div>

              <div>
                <div className="text-[#82808D]">
                  Start Date:
                </div>
                <div>{starts_on}</div>
              </div>
            </div>

            {/* end date */}
            <div className="flex items-start gap-2 rounded-2xl border border-[#5A277C] px-2 py-1">
              <div>
                <img
                  src={CALENDAR_BLANK_ICON}
                  alt={ends_on}
                  className="mt-1"
                  loading="lazy"
                />
              </div>

              <div>
                <div className="text-[#82808D]">
                  End Date:
                </div>
                <div>{ends_on}</div>
              </div>
            </div>

            {/* validity */}
            <div className="flex items-start gap-2 rounded-2xl border border-[#5A277C] px-2 py-1">
              <div>
                <img
                  src={CALENDAR_ICON}
                  alt={validity}
                  className="mt-1"
                  loading="lazy"
                />
              </div>

              <div>
                <div className="text-[#82808D]">
                  Validity:
                </div>
                <div>{validity}</div>
              </div>
            </div>

            {/* total hours */}
            <div className="flex items-start gap-2 rounded-2xl border border-[#5A277C] px-2 py-1">
              <div>
                <img
                  src={CLOCK_ICON}
                  alt={duration}
                  className="mt-1"
                  loading="lazy"
                />
              </div>

              <div>
                <div className="text-[#82808D]">
                  Total Hours:
                </div>
                <div>{duration}</div>
              </div>
            </div>
          </div>
        </div>

        {/* =========================
            PRICE + PAYMENT PLANS
        ========================== */}

        {plans.length > 0 && (
          <div className="mx-[1rem] mb-4">
            <div className="mb-2 text-sm font-semibold text-[#82808D]">
              Payment Plans
            </div>

            <div className="grid grid-cols-3 gap-2">
              {plans.slice(0, 4).map((plan) => {
                const discount = Number(
                  plan?.offer_discount || 0
                );

                const hasDiscount = discount > 0;

                const finalPrice = hasDiscount
                  ? plan?.offer_price
                  : plan?.price;

                return (
                  <div
                    key={plan?.id}
                    className="
                      min-w-0
                      rounded-xl
                      border
                      border-[#E2D9E8]
                      bg-white
                      px-2
                      py-2
                      text-center
                      shadow-sm
                    "
                  >
                    {/* Discount */}
                    {hasDiscount && (
                      <div className="mb-1 text-[9px] font-semibold text-[#5A277C]">
                        {discount}% OFF
                      </div>
                    )}

                    {/* Original Price */}
                    {hasDiscount && (
                      <div className="text-[9px] text-gray-400 line-through">
                        ₹{plan?.price}
                      </div>
                    )}

                    {/* Final Price */}
                    <div className="text-sm font-bold text-[#5A277C]">
                      ₹{finalPrice}
                    </div>

                    {/* Validity */}
                    <div className="text-[9px] font-medium text-[#77747C]">
                      for {plan?.validity || 0} Months
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* =========================
            PRICE + BUY BUTTON
        ========================== */}

        <div className="my-[1rem] mx-[1rem] flex items-center justify-between">
          {/* Price */}
          <div className="flex items-center gap-1">
            <div>
              {offer_discount !== "0" &&
              offer_discount !== null ? (
                <div className="w-10 rounded-l-full rounded-r-full bg-[#5A277C] p-1 text-center text-xs text-white">
                  {offer_discount}% off
                </div>
              ) : (
                ""
              )}
            </div>

            {/* <div className="flex flex-col">
              {offer_discount !== "0" &&
                offer_discount !== null && (
                  <div className="text-gray-500 line-through">
                    ₹{price}
                  </div>
                )}

              <div className="rounded-2xl bg-[#5A277C] px-4 py-2 text-white">
                ₹
                {offer_discount !== "0" &&
                offer_discount !== null
                  ? offer_price
                  : price}
              </div>
            </div> */}
          </div>

          {/* Buttons */}
          <div
            className={`flex gap-3 rounded-2xl px-4 py-2 ${
              is_purchased === "1"
                ? ""
                : "bg-[#5A277C] !text-white"
            }`}
          >
            {/* Buy Now */}
            {is_purchased === "0" && (
              <div>
                <button
                  className="cursor-pointer rounded-xl p-0 py-1"
                  style={{
                    fontWeight: 700,
                  }}
                  onClick={openBuyPopup}
                >
                  Buy Now
                </button>
              </div>
            )}

            {/* Purchased */}
            {is_purchased === "1" && (
              <div>
                <div className="w-[10rem] rounded-xl bg-gradient-to-r from-cyan-400 to-purple-600 py-1 text-center font-semibold text-white">
                  Course Purchased
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* =========================
          PAYMENT PLAN POPUP
      ========================== */}

  {showPlanPopup && (
  <div
    className="
      fixed
      inset-0
      z-[99999]
      flex
      items-center
      justify-center
      overflow-y-auto
      bg-black/50
      px-[5px]
      py-4
      sm:px-3
    "
  >
    <div
      className="
        relative
        my-auto
        max-h-[90vh]
        w-[calc(100%-10px)]
        max-w-md
        overflow-y-auto
        rounded-2xl
        bg-white
        p-4
        shadow-2xl
        sm:w-full
        sm:p-4
      "
      style={{ fontFamily: "DM Sans" }}
    >
      {/* Close */}
      <button
        type="button"
        onClick={() => {
          setShowPlanPopup(false);
          setSelectedPlan(null);
        }}
        className="
          absolute
          right-3
          top-2
          text-xl
          text-gray-500
          hover:text-gray-800
          sm:right-4
          sm:top-3
        "
      >
        ×
      </button>

      {/* Heading */}
      <div className="mb-4 pr-6">
        <h2 className="text-lg font-bold text-[#222]">
          Select Payment Plan
        </h2>

        <p className="mt-1 text-xs text-[#77747C]">
          {name}
        </p>
      </div>

      {/* Plans */}
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {plans.map((plan) => {
          const discount = Number(plan?.offer_discount || 0);
          const hasDiscount = discount > 0;

          const finalPrice = hasDiscount
            ? plan?.offer_price
            : plan?.price;

          const isSelected =
            selectedPlan?.id === plan?.id;

          return (
            <button
              type="button"
              key={plan?.id}
              onClick={() => setSelectedPlan(plan)}
              className={`
                min-w-0
                rounded-xl
                border
                px-2
                py-3
                text-center
                transition-all
                ${
                  isSelected
                    ? "border-[#5A277C] bg-[#F5ECF9] ring-2 ring-[#5A277C]/20"
                    : "border-[#DDD8E2] bg-white hover:border-[#5A277C]"
                }
              `}
            >
              <div className="text-sm font-bold text-[#5A277C]">
                ₹{finalPrice}
              </div>

              {hasDiscount && (
                <div className="text-[10px] text-gray-400 line-through">
                  ₹{plan?.price}
                </div>
              )}

              <div className="mt-1 text-xs font-semibold text-[#333]">
                {plan?.validity || 0} Months
              </div>

              {hasDiscount && (
                <div className="mt-1 text-[10px] font-semibold text-[#5A277C]">
                  {discount}% OFF
                </div>
              )}
            </button>
          );
        })}
      </div>

      {/* Continue */}
      <button
        type="button"
        disabled={!selectedPlan}
        onClick={continueToPayment}
        className={`
          mt-5
          w-full
          rounded-xl
          py-2.5
          text-sm
          font-bold
          transition-all
          ${
            selectedPlan
              ? "bg-[#5A277C] text-white hover:bg-[#472063]"
              : "cursor-not-allowed bg-gray-200 text-gray-400"
          }
        `}
      >
        Continue to Payment
      </button>
    </div>
  </div>
)}
    </>
  );
};

export default DescriptionTop;